import { Paper, Group, Text } from '@mantine/core'

interface StatCardProps {
  title: string
  total: number
  totalSuffix?: React.ReactNode
  footer: React.ReactNode
}

export const StatCard = ({ title, total, totalSuffix, footer }: StatCardProps) => {
  return (
    <Paper className='rounded-[1.25rem]' p='xl' color='white' radius='md'>
      <Group>
        <div>
          <Text c='dimmed' tt='uppercase' fw={700} fz='xs'>
            {title}
          </Text>
          <Group align='center' className='mt-2'>
            <Text fw={700} fz='xl'>
              {total.toLocaleString()}
            </Text>
            {totalSuffix}
          </Group>
        </div>
      </Group>
      <div className='mt-3'>{footer}</div>
    </Paper>
  )
}
